(function () {
  /* Hero Slider */
  document.querySelectorAll('[data-prime-hero-slider]').forEach(function (hero) {
    var slides = Array.from(hero.querySelectorAll('.prime-hero__slide'));
    if (slides.length <= 1) return;

    var current = 0;
    var autoplay = hero.dataset.autoplay === 'true';
    var speed = (parseInt(hero.dataset.speed, 10) || 5) * 1000;
    var timer = null;
    var dots = Array.from(hero.querySelectorAll('[data-prime-hero-dot]'));
    var prevBtn = hero.querySelector('[data-prime-hero-prev]');
    var nextBtn = hero.querySelector('[data-prime-hero-next]');

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      if (autoplay) {
        timer = setInterval(next, speed);
      }
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function flashArrow(btn) {
      if (!btn) return;
      btn.classList.add('is-pressed');
      window.setTimeout(function () {
        btn.classList.remove('is-pressed');
      }, 350);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        flashArrow(prevBtn);
        prev();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        flashArrow(nextBtn);
        next();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        flashArrow(dot);
        goTo(parseInt(dot.dataset.primeHeroDot, 10));
        startAutoplay();
      });
    });

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });

  /* FAQ Accordion */
  document.querySelectorAll('.prime-faq__list').forEach(function (list) {
    list.querySelectorAll('.prime-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.prime-faq__item');
        var isOpen = item.classList.contains('is-open');

        list.querySelectorAll('.prime-faq__item').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.prime-faq__question').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  /* Testimonials Slider */
  document.querySelectorAll('[data-prime-testimonials]').forEach(function (section) {
    var track = section.querySelector('.prime-testimonials__track');
    var cards = track ? Array.from(track.querySelectorAll('[data-prime-slide]')) : [];
    var dotsContainer = section.querySelector('[data-prime-dots]');
    if (!cards.length) return;

    var current = 0;
    var visible = window.innerWidth >= 990 ? 3 : 1;

    function updateVisible() {
      visible = window.innerWidth >= 990 ? 3 : 1;
      if (current > cards.length - visible) {
        current = Math.max(0, cards.length - visible);
      }
      render();
    }

    function renderDots() {
      if (!dotsContainer) return;

      var isMobile = window.innerWidth < 990;
      if (!isMobile || visible !== 1) {
        dotsContainer.innerHTML = '';
        dotsContainer.setAttribute('hidden', '');
        return;
      }

      dotsContainer.removeAttribute('hidden');

      if (dotsContainer.children.length !== cards.length) {
        dotsContainer.innerHTML = '';
        cards.forEach(function (_card, index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'prime-testimonials__dot';
          dot.setAttribute('aria-label', 'Go to testimonial ' + (index + 1));
          dot.addEventListener('click', function () {
            current = index;
            render();
          });
          dotsContainer.appendChild(dot);
        });
      }

      Array.from(dotsContainer.children).forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === current);
      });
    }

    function render() {
      cards.forEach(function (card, i) {
        card.style.display = i >= current && i < current + visible ? '' : 'none';
      });
      renderDots();
    }

    var prev = section.querySelector('[data-prime-prev]');
    var next = section.querySelector('[data-prime-next]');

    if (prev) {
      prev.addEventListener('click', function () {
        current = Math.max(0, current - 1);
        render();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        current = Math.min(cards.length - visible, current + 1);
        render();
      });
    }

    window.addEventListener('resize', updateVisible);
    render();
  });
})();
